import { useRef } from "react";
import oInfo from "../info.json";
import "./Styles/Navbar.css";

//Multimedia
import Logo from "../Multimedia/Icons/logo.svg";
import Close from "../Multimedia/Icons/close.svg";
import Hamburger from "../Multimedia/Icons/hamburger.svg";

const NavbarComponent = () => {
  const { sBrand, aNavbarLinks } = oInfo.oNavbar;
  const oHamburgerMenu = useRef(null);
  return (
    <nav className="flex-row navbar" id="navbar">
      <div className="flex-row flex-center brand-container">
        <img
          className="logo"
          src={Logo}
          alt="Logo SVG"
          width="50px"
          height="50px"
        />
        <h2 className="brand-text">{sBrand}</h2>
      </div>

      <div className="flex-row nav-links">
        {aNavbarLinks.map((sNavLink) => {
          return (
            <a
              href={`#${sNavLink.toLowerCase() + "-section"}`}
              className="nav-link"
              key={sNavLink}
            >
              {sNavLink}
            </a>
          );
        })}
      </div>

      <div className="hamburger-menu close" ref={oHamburgerMenu}>
        <img
          className="close-icon close"
          src={Close}
          alt="=Close SVG"
          width="50px"
          height="50px"
          onClick={() => {
            oHamburgerMenu.current.classList.toggle("open");
          }}
        />
        <img
          className="hamburger-icon close"
          src={Hamburger}
          alt="=Close SVG"
          width="50px"
          height="50px"
          onClick={() => {
            oHamburgerMenu.current.classList.toggle("open");
          }}
        />
        <div className="mobile-menu">
          <div className="flex-column mobile-nav-links close">
            {aNavbarLinks.map((sNavLink) => {
              return (
                <a
                  href={`#${sNavLink.toLowerCase() + "-section"}`}
                  className="mobile-nav-link"
                  key={sNavLink}
                  onClick={() => {
                    oHamburgerMenu.current.classList.toggle("open");
                  }}
                >
                  {sNavLink}
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default NavbarComponent;
